// TODO: temporary solution, in original, BE API used - remove once implemented
import { Component, inject } from '@angular/core';
import { SystemService } from '../../../shared/service/system/system.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { LogoComponent } from '../../../shared/svg/logo/logo.component';

@Component({
  selector: 'app-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss'],
  standalone: true,
  imports: [TranslateModule, LogoComponent],
})
export class TimeoutComponent {
  protected systemService = inject(SystemService);
  translate = inject(TranslateService);

  constructor() {
    console.log(' >>>> Timeout constructor');
  }
}
